import styled from 'styled-components';

import { BREAKPOINTS } from 'constants/Global/Breakpoints.const';
import { darken } from 'polished';

export const Gallery = styled.div.attrs({
  className: 'Gallery',
})`
  display: flex;
  align-items: flex-start;
  width: 100%;
  padding: 16px;

  @media (min-width: ${BREAKPOINTS.phone}) {
    flex-direction: column;
    border-bottom: 1px solid #d9d9d9;
  }

  @media (min-width: ${BREAKPOINTS.tabletMini}) {
    flex-direction: row;
  }

  @media (min-width: ${BREAKPOINTS.tablet}) {
    border-bottom: 0;
  }
`;

export const ImagesListBackground = styled.div`
  padding-bottom: 8px;

  @media (min-width: ${BREAKPOINTS.tabletMini}) {
    padding-bottom: 0;
    padding-right: 16px;
  }

  &::-webkit-scrollbar {
    width: 4px;
    height: 4px;
    background: #f5f5f5;
  }

  &::-webkit-scrollbar-track {
    background-color: #f5f5f5;
  }

  &::-webkit-scrollbar-thumb {
    background: #d9d9d9;
  }
`;

export const ImagesList = styled.div.attrs({
  className: 'ImagesList',
})`
  display: flex;
  flex-direction: row;
  gap: 8px;
  justify-content: center;
  align-items: center;
  div {
    cursor: pointer;
    margin: 0;
  }

  @media (min-width: ${BREAKPOINTS.tabletMini}) {
    flex-direction: column;
  }
`;

export const ImagesDisplay = styled.div.attrs({
  className: 'ImagesDisplay',
})`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  overflow: hidden;

  img {
    border: 1px solid #d9d9d9;
    width: 100%;
  }
`;

export const ImageLabel = styled.div`
  font-size: 0.875rem;
  font-weight: 400;
`;

export const ImageNavigation = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  .image-numbers {
    border: 1px solid #d9d9d9;
    padding: 4px 8px;
  }

  button {
    background: none;
    border: none;
    font-size: 16px;
    cursor: pointer;
    border: 1px solid #d9d9d9;
    width: 32px;
    height: 32px;

    &:disabled {
      cursor: not-allowed;
      background: ${() => darken(0.1, '#FFFFFF')};
      color: #bfbfbf;
    }
  }
`;
